import { useMemo } from "react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import moment from "moment";
import { tableConfig } from "../../../commons/table/config/tableConfig";

import HistorialTrasladosTramos from "./historialTrasladosTramos";

const formatTrasladoLabel = (row) => `T-${row.nroTraslado ?? row.idTraslado}`;

const formatDistancia = (value) => {
  if (value === null || value === undefined) {
    return "—";
  }
  return `${Number(value).toLocaleString("es-AR", { maximumFractionDigits: 1 })} km`;
};

const HistorialTrasladosTable = ({ data, loading }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "nroTraslado",
        header: "Traslado",
        size: 90,
        minSize: 90,
        grow: false,
        Cell: ({ row }) => <b>{formatTrasladoLabel(row.original)}</b>,
      },
      {
        accessorKey: "fechaHoraTraslado",
        header: "Fecha y hora",
        size: 130,
        minSize: 130,
        grow: false,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? moment(value).format("DD/MM/YYYY HH:mm") : "—";
        },
      },
      {
        accessorKey: "agencia",
        header: "Agencia",
        Cell: ({ cell }) => cell.getValue() || "—",
      },
      {
        accessorKey: "distanciaKm",
        header: "Distancia",
        size: 90,
        minSize: 90,
        grow: false,
        Cell: ({ cell }) => formatDistancia(cell.getValue()),
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    ...tableConfig,
    enableRowActions: false,
    state: { isLoading: loading },
    renderDetailPanel: ({ row }) => (
      <HistorialTrasladosTramos
        trasladoLabel={formatTrasladoLabel(row.original)}
        tramos={row.original.tramos || []}
      />
    ),
  });

  return (
    <Box sx={{ mt: 1 }}>
      <MaterialReactTable table={table} />
    </Box>
  );
};

export default HistorialTrasladosTable;
